import { render, staticRenderFns } from "./EStatusBadge.vue?vue&type=template&id=07d837fb&"
import script from "./EStatusBadge.vue?vue&type=script&lang=js&"
export * from "./EStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./EStatusBadge.vue?vue&type=style&index=0&id=07d837fb&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d837fb')) {
      api.createRecord('07d837fb', component.options)
    } else {
      api.reload('07d837fb', component.options)
    }
    module.hot.accept("./EStatusBadge.vue?vue&type=template&id=07d837fb&", function () {
      api.rerender('07d837fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/EStatusBadge.vue"
export default component.exports